import React from 'react'
import styles from './VNProcessing.module.scss'
import VNLoader from '../../VNLoader/components/VNLoader'

export const VNProcessing = (props) => {
  // SELECTORS

  // LOCAL STATE

  // USE EFFECTS
  // 1005 by 556/605

  return (
    <div className={styles.wrapper}>
      <VNLoader processing className={styles.loader} />
      <h1 className={styles.title}>Processing...</h1>
      <h3 className={styles.subtitle}>Please wait.</h3>
    </div>
  )
}
